import "./component6.scss";
import React from "react";
import giftCard_5000 from "../../Images/giftCards/gift_card_5000.png";
import giftCard_10000 from "../../Images/giftCards/gift_card_10000.png";
import { PHONE_BOOKING_DISPLAY, PHONE_BOOKING_TEL } from "../../constants/contact";

const Component6 = () => {
  return (
    <section className="gifts component6" id="gifts">
      <div className="container">
        <p className="section-label gifts__label">Подарочный сертификат</p>
        <h2 className="gifts__title">Идеальный подарок поклоннику бильярда</h2>
        <p className="gifts__lead">
          Оформление и условия — по телефону:{" "}
          <a href={PHONE_BOOKING_TEL}>{PHONE_BOOKING_DISPLAY}</a>.
        </p>

        <div className="gifts__grid">
          <figure className="gifts__figure">
            <img src={giftCard_5000} alt="Подарочный сертификат 5000" loading="lazy" />
          </figure>
          <figure className="gifts__figure">
            <img src={giftCard_10000} alt="Подарочный сертификат 10000" loading="lazy" />
          </figure>
        </div>

        <div className="gifts__cta-row">
          <a className="cta-phone" href={PHONE_BOOKING_TEL}>
            Узнать о сертификатах
          </a>
        </div>
      </div>
    </section>
  );
};

export default Component6;
